import { BrowserRouter, Routes, Route } from "react-router-dom";
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import './App.css';
import { UsersProvider } from "./context/UsersContext";

import { AuthProvider } from "./context/AuthContext";
import { ProductProvider } from "./context/ProductContext";
import { CartProvider    } from "./context/CartContext";
import { OrderProvider   } from "./context/OrderContext";

import AdminRoutes from "./routes/AdminRoutes";
import ClientRoutes from "./routes/ClientRoutes";
console.log({ AdminRoutes, ClientRoutes, AuthProvider, ProductProvider });

export default function App() {
  return (
    
    <AuthProvider>
      <ProductProvider>
        <UsersProvider>
          <CartProvider> 
          <OrderProvider>
          <BrowserRouter>
            <Routes>
              <Route path="/admin/*" element={<AdminRoutes />} />
              <Route path="/*" element={<ClientRoutes />} />
            </Routes>
          </BrowserRouter>
          </OrderProvider>
          </CartProvider> 
        </UsersProvider>
      </ProductProvider>
    </AuthProvider>
  );
}